import React from 'react';

interface LevelUpIconProps {
    width?: string | number;
    height?: string | number;
}

const LevelUpIcon: React.FC<LevelUpIconProps> = ({ width = 60, height = 60 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3_17567)">
                <circle cx="30" cy="30" r="30" fill="#15C9E2" fillOpacity="0.1"/>
                <path d="M15.6284 54.8987L49.3784 31.9491L18.6284 14.1955L15.6284 54.8987Z" fill="#15C9E2"/>
                <path d="M38.9496 36.321L14.0568 21.9491L13.5715 28.5337L33.4899 40.0336L38.9496 36.321Z" fill="#7E2CF5" fillOpacity="0.7"/>
                <path d="M22.6283 14.1954L53.3783 31.9489L46.9497 36.3203L22.0569 21.9484L22.6283 14.1954Z" fill="#E42044" fillOpacity="0.7"/>
                <rect x="29.4668" y="7.92944" width="4.30954" height="4.30954" fill="#7E2CF5"/>
                <rect x="48.6893" y="8.63525" width="4.30954" height="4.30954" fill="#FF4A6B"/>
                <rect x="38.3949" y="10.6001" width="2.17522" height="2.17522" fill="#FF4A6B"/>
                <rect x="37.5417" y="16" width="2.93505" height="2.93505" transform="rotate(60 37.5417 16)" fill="#16D7B4"/>
                <rect x="46.5248" y="19.9998" width="4.07028" height="4.07028" transform="rotate(60 46.5248 19.9998)" fill="#15C9E2"/>
                <rect x="41.0865" y="2.91309" width="3.10939" height="3.10939" transform="rotate(60 41.0865 2.91309)" fill="#15C9E2"/>
                <rect x="46.9408" y="15.5305" width="2.93505" height="2.93505" transform="rotate(117.99 46.9408 15.5305)" fill="#FDD000"/>
                <rect x="31.6619" y="15.9238" width="1.9684" height="1.9684" transform="rotate(117.99 31.6619 15.9238)" fill="#FDD000"/>
                <circle cx="16.7533" cy="52.95" r="3.5" transform="rotate(30 16.7533 52.95)" fill="#FDD000"/>
            </g>
            <defs>
                <clipPath id="clip0_3_17567">
                    <rect width="60" height="60" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default LevelUpIcon;

